// client/src/components/ai/GerarImagemIABox.js
// Caixa reutilizável de geração de IMAGEM por IA (Venice.ai) — usada em
// Serviços, Itens de Venda, Recursos, Cursos, Pacotes, Ofertas e
// Conteúdos da Home. Gera uma imagem a partir de um prompt e devolve um
// File pronto pra entrar no MESMO input de upload manual que a tela já
// tem (via onUseImage) — não salva nada sozinho. Mesmo padrão visual do
// GerarComIA de BannersHomeFormPage.js, generalizado.
import React, { useEffect, useState } from 'react';
import { Sparkles, Loader2, ImageIcon } from 'lucide-react';
import { useGerarImagemIA } from '../../hooks/useAIGeracao';
import { useGeracaoIAGate, GeracaoIAUpsellBanner } from './useGeracaoIAGate';

const GerarImagemIABox = ({
    aspectRatio = '1:1',
    aspectHint,
    onUseImage,
    placeholder = 'Descreva a imagem que você quer gerar...',
    itemContexto,
}) => {
    const [prompt, setPrompt] = useState('');
    const [resultado, setResultado] = useState(null); // { file, previewUrl }
    const gerarImagem = useGerarImagemIA();
    const { podeGerarComIA, planPermiteIA } = useGeracaoIAGate();

    const handleGerar = () => {
        if (!prompt.trim()) return;
        gerarImagem.mutate(
            { prompt, aspectRatio, itemContexto },
            { onSuccess: (data) => setResultado(data) }
        );
    };

    useEffect(() => {
        return () => {
            if (resultado?.previewUrl) URL.revokeObjectURL(resultado.previewUrl);
        };
    }, [resultado]);

    if (!podeGerarComIA) {
        return <GeracaoIAUpsellBanner planPermiteIA={planPermiteIA} />;
    }

    return (
        <div className="ai-gerar-box-imagem mt-4 p-3 bg-purple-50 rounded border border-purple-200">
            <p className="text-sm font-medium mb-2 flex items-center gap-2">
                <ImageIcon size={16} className="text-purple-600" /> Gerar Imagem com IA
            </p>
            {aspectHint && <p className="form-hint mb-2">{aspectHint}</p>}
            <div className="flex flex-col md:flex-row gap-2">
                <textarea
                    className="form-input flex-grow"
                    rows={2}
                    placeholder={placeholder}
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    disabled={gerarImagem.isPending}
                />
                <button
                    type="button"
                    className="action-button action-button-secondary"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={handleGerar}
                    disabled={!prompt.trim() || gerarImagem.isPending}
                >
                    {gerarImagem.isPending ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />}
                    {gerarImagem.isPending ? 'Gerando...' : 'Gerar'}
                </button>
            </div>

            {resultado && (
                <div className="mt-3 p-3 border rounded bg-white flex flex-col md:flex-row items-start gap-4">
                    <img src={resultado.previewUrl} alt="Gerado por IA" className="rounded" style={{ maxWidth: 200, maxHeight: 140, objectFit: 'contain' }} />
                    <div className="flex-grow">
                        <button
                            type="button"
                            className="action-button action-button-primary"
                            onClick={() => onUseImage(resultado.file, resultado.previewUrl)}
                        >
                            Usar esta imagem
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GerarImagemIABox;
